import {Injectable} from '@angular/core';
import { getLanguage, parse, pick } from '../helpers/parser/language-header.parser';


export const DefaultLocale = 'en';


/***
 * An angular service which allows to gets the locale set for the application.
 * It takes from ParamMap set ui_locales basically
 * */
@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  constructor() { }

  public getLocaleToLoad = (locale: string | undefined, supportedLanguage: string[]): string => {
    const langToLoad = this.getLanguages(locale);
    const sortedSupportedLocale = this.sortSupportedLocale(supportedLanguage, langToLoad);
    return this.pickLanguage(sortedSupportedLocale, langToLoad);
  }

  private sortSupportedLocale(supportedLocale: string[], langToLoad: string[]) {
    // Sort arrayA based on the index of its elements in arrayB
    return supportedLocale
      .map(a => a)
      .sort((a, b) => {
        // Get the index of a and b in arrayB
        const indexA = langToLoad.indexOf(a);
        const indexB = langToLoad.indexOf(b);

        // If both elements are not found in arrayB, maintain the original order
        if (indexA === -1 && indexB === -1) {
          return 0;
        }
        // If a is not found in arrayB, move it to the end
        else if (indexA === -1) {
          return 1;
        }
        // If b is not found in arrayB, move it to the end
        else if (indexB === -1) {
          return -1;
        }
        // Otherwise, sort based on their indices in arrayB
        else {
          return indexA - indexB;
        }
    });
  }


  private getDelimiter = (language: string): string => {
    return language.includes(';') && ';' || ' ';
  }


  private getLanguages = (language?: string): string[] => {
    if (!language) {
      return [ ...navigator.languages ];
    }

    return [ ...parse(language, this.getDelimiter(language)).map(l => getLanguage(l)), ...navigator.languages ];
  }



  private pickLanguage = (languages: string[], acceptLanguage: string[]): string => {
    return pick(languages, acceptLanguage)
      || DefaultLocale;
  }

}

